<mat-tab-group [@.disabled]="true">
  <mat-tab>
    <ng-template mat-tab-label>
      Mach
    </ng-template>
    <ng-template matTabContent>
      <div class="content-center">
        <rpe-if-mach></rpe-if-mach>
      </div>
    </ng-template>

  </mat-tab>

  <mat-tab>
    <ng-template mat-tab-label>
      p/p<sub>0</sub>
    </ng-template>
    <ng-template matTabContent>
      <div class="content-center">
        <rpe-if-pp0></rpe-if-pp0>
      </div>
    </ng-template>
  </mat-tab>
    
    
  <mat-tab>
    <ng-template mat-tab-label>
      T/T<sub>0</sub>
    </ng-template>
    <ng-template matTabContent>
      <rpe-if-tt0></rpe-if-tt0>
        <!-- T/T<sub>0</sub> -->
    </ng-template>
  </mat-tab>

  <mat-tab>
    <ng-template mat-tab-label>
      A/A<sub>t</sub>
    </ng-template>
    <ng-template matTabContent>
      <!-- A/A<sub>t</sub> -->
      <rpe-if-aat></rpe-if-aat>
    </ng-template>
  </mat-tab>

  <mat-tab>
    <ng-template mat-tab-label>
      pA / p<sub>0</sub>A<sub>t</sub>
    </ng-template>
    <ng-template matTabContent>

      <rpe-if-pap0></rpe-if-pap0>

      <!-- pA / p<sub>0</sub>A<sub>t</sub> -->
    </ng-template>
  </mat-tab>




</mat-tab-group>